export const Moves: import('../../../sim/dex-moves').ModdedMoveDataTable = {
	aeroblast: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	astralbarrage: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	coreenforcer: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	crushgrip: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	diamondstorm: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	dragonascent: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	dragonenergy: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	eeriespell: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	fierywrath: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	freezingglare: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	geomancy: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	glaciallance: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	iceball: {
		inherit: true,
		desc: "If this move is successful, the user is locked into this move and cannot make another move until it misses, 5 turns have passed, or the attack cannot be used. Power doubles with each successful hit of this move and doubles again if Defense Curl was used previously by the user. If this move is called by Sleep Talk, the move is used for one turn. If this move hits an active Disguise or Ice Face during the effect, the power multiplier is paused but the turn counter is not, potentially allowing the multiplier to be used on the user's next move after this effect ends.",
		shortDesc: "Power doubles with each hit. Repeats for 5 turns.",
	},
	landswrath: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lovelykiss: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lunardance: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lusterpurge: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	magmastorm: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	mindblown: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	mistball: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	naturesmadness: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	oblivionwing: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	originpulse: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	precipiceblades: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	roaroftime: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	rollout: {
		inherit: true,
		desc: "If this move is successful, the user is locked into this move and cannot make another move until it misses, 5 turns have passed, or the attack cannot be used. Power doubles with each successful hit of this move and doubles again if Defense Curl was used previously by the user. If this move is called by Sleep Talk, the move is used for one turn. If this move hits an active Disguise or Ice Face during the effect, the power multiplier is paused but the turn counter is not, potentially allowing the multiplier to be used on the user's next move after this effect ends.",
		shortDesc: "Power doubles with each hit. Repeats for 5 turns.",
	},
	sacredfire: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	searingshot: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	shadowforce: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	spacialrend: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	steameruption: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	technoblast: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	thousandarrows: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	thousandwaves: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	thundercage: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	thunderouskick: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
};
